module.exports = "<ol class=\"g-admin-breadcrumb\">\n  <li *ngFor=\"let item of list\">\n    {{ item }}\n  </li>\n</ol>"